import { render, staticRenderFns } from "./FileStatus.vue?vue&type=template&id=252a60c3&scoped=true&"
import script from "./FileStatus.vue?vue&type=script&lang=js&"
export * from "./FileStatus.vue?vue&type=script&lang=js&"
import style0 from "./FileStatus.vue?vue&type=style&index=0&id=252a60c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a60c3",
  null
  
)

export default component.exports